export default __webpack_public_path__ + "a8370b53fe08a5a54df257ace6067e8a.png";